// extracted by mini-css-extract-plugin
export default {"main-view":"RestaurantMenu_main-view__pQWJ8"};